import { forwardRef } from 'react'
import clsx from 'clsx'
import { basePropsObj } from './SvgIcon'

const EmptyIcon = forwardRef(({ size = 150, tip = '', className = '', style = basePropsObj }, ref) => {

  return (
    <div>空组件</div>
  )

})

export {
  EmptyIcon
}